<!-- src/pages/MyPage.vue -->
<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { usePaymentsStore } from '@/store/modules/payments';

definePage({ meta: { layout: 'purchase' } });

const router = useRouter();
const route = useRoute();

const paymentsStore = usePaymentsStore();

const billResultMsg = ref(null);
// 이동할 페이지 정보
const next = ref('/main');

billResultMsg.value = '낭만 포인트 충전이 완료되었습니다!';

onMounted(() => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-10814485333/UF0SCK_t14waENXm36Qo',
    });
  }

  paymentsStore.getOwnPoint();
  paymentsStore.fetchTicketCount();

  if (route.query?.next) {
    // [Fix] 인코딩된 URL을 디코딩하여 사용
    next.value = decodeURIComponent(route.query?.next);
  }
});

const handleSubmit = () => {
  router.push(next.value);
};

const goService = () => {
  router.push('/mypage/history');
};
</script>

<template>
  <div class="my-info-wrap purchase-finish-page">
    <div class="my-tit-box com-bg-my-box h-small">
      <div class="tit">포인트 충전</div>
      <div class="path">
        <ul>
          <li>홈</li>
          <li>서비스구매</li>
          <li>낭만 포인트 충전</li>
        </ul>
      </div>
    </div>
    <div class="myinfo-box com-bg-my-box">
      <div class="finish-box">
        <div class="com-btn-box"><i class="icon-check"></i></div>
        <div class="gap-xxl"></div>
        <div class="fnt-big">{{ billResultMsg }}</div>
        <div class="gap-xxl"></div>
        <div class="com-btn-box">
          <VBtn type="button" class="com-btn-box__text" style="width: 100%" @click="handleSubmit">
            서비스 이용하기
          </VBtn>
        </div>
        <!-- <div class="gap-xxl"></div> -->
      </div>
    </div>
    <div class="payment-end-msg-box">
      결제 완료된 내역은 이용중인 서비스에서 확인할 수 있습니다.
      <button class="btn-txt-line" @click="goService">이용중인 서비스 바로가기</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.purchase-finish-page {
  .finish-box {
    max-width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 768px) {
  .purchase-finish-page {
    width: 100vw;
    margin-bottom: 0;
    /* 콘텐츠가 상단에 박히지 않도록 보이는 영역을 채우고 세로 중앙 정렬 */
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .my-tit-box {
      display: none;
    }

    .myinfo-box.com-bg-my-box {
      margin-bottom: 0;
      border-radius: 0;
      padding: 0;
    }

    .finish-box {
      width: 100%;
      padding: 48px 20px 36px;
      /* 메시지가 2줄로 줄바꿈돼도 가운데 정렬 유지 (.fnt-big 기본 left) */
      text-align: center;
    }

    .payment-end-msg-box {
      flex-direction: column;
      gap: 6px;
      margin-top: 0;
      padding: 16px 20px 24px;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
    }

    .payment-end-msg-box .btn-txt-line {
      margin-left: 0;
    }
  }
}
</style>
